import * as con from '../../GlobalConstants.js'
import { GenericCell } from '../../templates/tables/Cells.js'
import { translateSpeed, } from '../../utils/translateFunctions.js'
import { RefGridStrategyHook} from '../hooks/gridStrategyHooks.js'
import { StateModelParameterHook } from '../hooks/ModelParameterHooks.js'
import { Button} from '@blueprintjs/core';


export const translateTargetBand = (value) => {
  const option = con.TARGET_BAND_OPTIONS.find((band) => band.value === value)
  return option ? option.label : ""
}

export const GridParams = () => {
  const start_level = RefGridStrategyHook(con.START_LEVEL)
  const stop_loss = RefGridStrategyHook(con.SL)
  const [speed, setSpeed] = StateModelParameterHook(con.STRATEGY_SPEED)
  const target = translateTargetBand(RefGridStrategyHook(con.TARGET_BAND))
  const [isAutomatic, setIsAutomatic] = StateModelParameterHook(con.AUTOMATIC_GRID);

  return (
    <>
      <div className="flex-fila" style={{marginBottom: "1rem"}}>
        <Button
          text="Automático" 
          onClick={() => setIsAutomatic(true)}
          outlined={!isAutomatic}
          className="selectedButton"
          style={{ marginRight: '10px' }}
        />
        <Button 
          text="Manual" 
          onClick={() => setIsAutomatic(false)}
          outlined={isAutomatic}
          className="selectedButton"
        />
      </div>
      <div className="flex-fila nonFixedTable">
        <div className="flex-celda header-row">STOP LOSS</div>
        <div className="flex-celda header-row">ARRANQUE</div>
        <div className="flex-celda header-row">BANDA OBJETIVO</div>
        <div className="flex-celda header-row">VELOCIDAD</div>
      </div>

      <div className="flex-fila nonFixedTable">
        <GenericCell
            evenRow
            cellType={con.MONEY}
            editing={false}
            value={stop_loss}
            currency={con.MONEY_COP}
          />
          <GenericCell
            evenRow
            cellType={con.MONEY}
            editing={false}
            value={start_level}
            currency={con.MONEY_COP}
          />
        <GenericCell
          evenRow
          cellType={con.TEXT}
          editing={false}
          value={target}
        />
        <GenericCell
          valueTranslator={translateSpeed}
          evenRow
          value = {speed}
          setValue={setSpeed}
          cellType={con.MULTIPLE_SELECTION}
          editing
          options={con.GRID_AVAILABLE_SPEED_TYPES}
        />
      </div>
    </>
  )
}

export default GridParams;
